var PropType = /*@__PURE__*/ (function () {
    function PropType() {
    }
    PropType.validate = function (value) {
        return true;
    };
    PropType.parseValue = function (value) {
        return value;
    };
    return PropType;
}());
export default PropType;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/core/prop-types/prop-type.class.ts
// module id = null
// module chunks = 